import { ModelBase } from 'store/model-base';

export class CmsAddonPlans extends ModelBase {
    public static storeName: string = 'cmsAddonPlans';

    public plans: CmsAddonPlan[];

    public isValidPlan(planId: string): boolean {
        return Boolean(this.plans.find((plan: CmsAddonPlan) => plan.planId === planId));
    }
}
